import { render, staticRenderFns } from "./NovelList.vue?vue&type=template&id=b6a7a816&scoped=true&"
import script from "./NovelList.vue?vue&type=script&lang=js&"
export * from "./NovelList.vue?vue&type=script&lang=js&"
import style0 from "./NovelList.vue?vue&type=style&index=0&id=b6a7a816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a7a816",
  null
  
)

export default component.exports